// GETTERS
export const ETPS_TO_SHOW = 'etp/ETPS_TO_SHOW'
export const PARAMS_TO_SEND = 'etp/PARAMS_TO_SEND'
export const ETP_ORDERS = 'etp/ETP_ORDERS'
export const PENDING_AMOUNT = 'etp/PENDING_AMOUNT'

// MUTATIONS
export const SET_ETPS = 'etp/SET_ETPS'
export const SET_SELECTED_ETP = 'etp/SET_SELECTED_ETP'
export const SET_PAGINATION = 'etp/SET_PAGINATION'
export const SET_TOTAL_ITEMS = 'etp/SET_TOTAL_ITEMS'
export const SET_IS_LOADING = 'etp/SET_IS_LOADING'
export const SET_FILTERS = 'etp/SET_FILTERS'
export const SET_BIDDING_DIALOG = 'etp/SET_BIDDING_DIALOG'
export const SET_INVESTORS = 'etp/SET_INVESTORS'
export const SET_SELECTED_INVESTOR = 'etp/SET_SELECTED_INVESTOR'
export const SET_ACCOUNTS = 'etp/SET_ACCOUNTS'
export const SET_SELECTED_ACCOUNT = 'etp/SET_SELECTED_ACCOUNT'
export const SET_ETP_PENDING_AMOUNT = 'etp/SET_ETP_PENDING_AMOUNT'
export const SET_BID_SIZE = 'etp/SET_BID_SIZE'
export const SET_CLEAR_BID_DATA = 'etp/SET_CLEAR_BID_DATA'
export const SET_IS_DIALOG_LOADING = 'etp/SET_IS_DIALOG_LOADING'

// ACTIONS
export const GET_ETPS = 'etp/GET_ETPS'
export const GET_ETP_DETAILS = 'etp/GET_ETP_DETAILS'
export const CHANGE_PAGINATION = 'etp/CHANGE_PAGINATION'
export const CHANGE_FILTERS = 'etp/CHANGE_FILTERS'
export const RESET_PAGINATION = 'etp/RESET_PAGINATION'
export const GET_INVESTORS = 'etp/GET_INVESTORS'
export const GET_SELECTED_INVESTOR = 'etp/GET_SELECTED_INVESTOR'
export const GET_ACCOUNTS = 'etp/GET_ACCOUNTS'
export const GET_SELECTED_ACCOUNT = 'etp/GET_SELECTED_ACCOUNT'
export const GET_BID_DATA = 'etp/GET_BID_DATA'
export const SET_ACCOUNT_BALANCE = 'etp/SET_ACCOUNT_BALANCE'
export const TOGGLE_BIDDING_DIALOG = 'etp/TOGGLE_BIDDING_DIALOG'
export const PLACE_BID = 'etp/PLACE_BID'
export const CANCEL_ETP = 'etp/CANCEL_ETP'
export const DEFAULT_ETP = 'etp/DEFAULT_ETP'
export const WRITE_OFF_ETP = 'etp/WRITE_OFF_ETP'
